<div class="demo-container">
  <nz-card class="card-body">
    <div class="demo-wrapper">
      <img class="logo" src="/assets/logo/medexam.png" alt="medexam" />
      <h1>{{'demoFinishedTitle' | translate}}</h1>
      <p class="demo-intro">{{'demoFinishedLead' | translate}}</p>
      <div class="score-block">
        <p class="score-value">{{ correctCount }} / {{ total }}</p>
        <p class="score-caption">{{'demoScoreCaption' | translate}}</p>
      </div>
      <a
        class="demo-primary-button purchase-button"
        nz-button
        nzType="primary"
        nzBlock
        [href]="purchaseUrl"
        target="_blank"
        rel="noopener noreferrer"
      >
        {{'demoPurchaseCta' | translate}}
      </a>
      <div class="demo-secondary-links">
        <a routerLink="/login">{{'demoLoginLink' | translate}}</a>
      </div>
    </div>
  </nz-card>
</div>
